import React,{useEffect,useRef,useState} from "react";
import css from "./NavItem.module.css";
import {PopupView} from "react-vritra";
import {TextView} from "Components";
import {tube0} from "Assets";


export default function NavItem(props){
    const {label,href,undertest,message}=props;
    const Tag=href?"a":"span";
    const tagRef=useRef();
    const [shown,setShown]=useState(false);
    useEffect(()=>{
        const timeout=shown&&setTimeout(()=>{
            setShown(false);
        },message?.length*30);
        return ()=>{
            clearTimeout(timeout);
        }
    },[shown]);
    return (
        <React.Fragment>
            <Tag 
                ref={tagRef}
                className={`button ${css.navitem}`}
                href={href||undefined}
                onClick={href?undefined:()=>{setShown(true)}}
            >   
                {label}
                {undertest&&
                    <img 
                        className={css.icon} 
                        alt="under test" 
                        src={tube0(mainColor)}
                        title="under test"
                    />
                }
            </Tag>
            {shown&&<PopupView 
                className={css.popupmsg}
                targetRef={tagRef}
                avoidable={true}
                onUnmount={()=>{setShown(false)}}
            >
                <TextView text={message}/>
            </PopupView>}
        </React.Fragment>
    )
}
